var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "InPlayerVideoOverlay",
    [
      _c(
        "OverlayContent",
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      😢 " + _vm._s(_vm.$t("unable-to-load")) + "\n    ")
          ]),
          _vm._v(" "),
          _c("template", { slot: "message" }, [
            _vm._v("\n      " + _vm._s(_vm.error && _vm.error.cause) + "\n    ")
          ]),
          _vm._v(" "),
          !_vm.isPlaybackBlocked
            ? _c(
                "OverlayButton",
                {
                  attrs: {
                    slot: "content",
                    tracker: _vm.getAnalyticPayload(function(e) {
                      return e.player["overlay-error-view"].click.refresh
                    }, _vm.$t("try-again"))
                  },
                  on: {
                    click: function($event) {
                      return _vm.performAction({
                        fn: _vm.refresh,
                        tracker: {
                          label: "try-again"
                        }
                      })
                    }
                  },
                  slot: "content"
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("try-again")) + "\n    ")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }